import {
	Button,
	ColourStateSolid,
	Modal,
	ModalType,
	ToggleSwitch,
	ToggleType,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { useState } from 'react';
import { CustomMailFoldersType } from '../../Types/MailboxProviderTypes';

interface DeleteCustomFolderModalType extends ModalType {
	deleteCustomFolderOpen: boolean;
	activeCustomFolderData: CustomMailFoldersType | null;
	DeleteCustomFolderCallback: (state: boolean) => void;
	ToggleDeleteCustomFolderModalCallback: (state: boolean) => void;
}

function DeleteCustomFolderModal(props: DeleteCustomFolderModalType) {
	const { t } = useTranslation();
	const [deleteChildFolders, setDeleteChildFolders] = useState<boolean>(false);

	return (
		<Modal
			title={t('customFolders.deleteFolder.title', { folder: props.activeCustomFolderData?.description })}
			isOpen={props.deleteCustomFolderOpen}
			closeCallback={() => props.ToggleDeleteCustomFolderModalCallback(false)}
		>
			<p>{t('customFolders.deleteFolder.description')}</p>
			{props.activeCustomFolderData?.childFolders && (
				<ToggleSwitch
					extraClass='mb-lg'
					name='DeleteChildFolders'
					label={t('customFolders.deleteFolder.labels.deleteChild')}
					type={ToggleType.Checkbox}
					defaultChecked={deleteChildFolders}
					onChange={() => setDeleteChildFolders(!deleteChildFolders)}
				/>
			)}
			<Button
				title={t('customFolders.deleteFolder.actions.deleteFolder')}
				fullWidth
				onClick={() => props.DeleteCustomFolderCallback(deleteChildFolders)}
				colour={ColourStateSolid.Primary}
			/>
		</Modal>
	);
}

export { DeleteCustomFolderModal };
